// extracted by mini-css-extract-plugin
export default {"wrap":"popup_wrap__lXnXS","title":"popup_title__EkUrX","buttonWrap":"popup_buttonWrap__MJuoR"};